import { Directive, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { DynamicTranslationService } from './dynamic-translation.service';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[ls-dynamic-translation]'
})
export class DynamicTranslationDirective implements OnInit {
  constructor(
    private elementRef: ElementRef,
    private renderer2: Renderer2,
    private dynamicTranslationService: DynamicTranslationService
  ) {
    this.renderer2.addClass(elementRef.nativeElement, 'u-state-hidden');
  }

  public ngOnInit(): void {
    this.dynamicTranslationService.translate(
      this.elementRef.nativeElement.id,
      this.elementRef.nativeElement.innerHTML
    );
  }
}
